@if (!submitting() && submittingSuccess()) {
<app-review-success-step></app-review-success-step>
} @else {
<section [formGroup]="formGroup!" ngxsForm="codDetail.investigationReviewDomesticForm">
    <h2 class="text-base font-bold text-font-primary">Investigation Review</h2>
    <p class="text-xs text-font-secondary">Enter any missing information or update the existing information below.</p>
    <div class="max-w-input flex flex-col gap-2 mt-4">
        <sag-ui-select
            [required]="true"
            label="Revise Nature of Complaint as a result of Investigation?"
            formControlName="natureOfComplaint"
        >
            @for (option of natureOfComplaint; track $index) {
            <sag-ui-option [value]="option">{{ option }}</sag-ui-option>
            }
            <sag-ui-option value="NO_CHANGE">No Change</sag-ui-option>
        </sag-ui-select>

        @if (formGroup.controls.natureOfComplaint.value !== 'NO_CHANGE') {
        <sag-ui-select [label]="label || 'Please select the revised nature of complaint'" formControlName="issueType">
            @for (option of options; track $index) {
            <sag-ui-option [value]="option">{{ option }}</sag-ui-option>
            }
        </sag-ui-select>
        }

        <sag-ui-select [required]="true" label="Root Cause" formControlName="rootCause">
            @for (option of rootCause | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>

        @if(formGroup.controls.rootCause.value === rootCause.HUMAN_ERROR) {
        <div class="max-w-input">
            <app-csr-responsible-select
                [formGroup]="formGroup"
                controlName="csrResponsible"
            ></app-csr-responsible-select>
        </div>
        } @else {
        <sag-ui-select [required]="true" label="Through" formControlName="through">
            @for (option of throughOptions | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>
        }
        <sag-ui-textarea
            [required]="true"
            label="Investigator Additional Details"
            formControlName="details"
        ></sag-ui-textarea>
        <app-attachments-input
            controlName="investigationReviewRelatedDocuments"
            [form]="formGroup!"
        ></app-attachments-input>
        <sag-ui-select
            [required]="true"
            label="Investigator COD Disposition"
            formControlName="investigatorReviewResult"
        >
            @for (option of basicReviewResult | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>
        @if (formGroup.controls.investigatorReviewResult.value === reviewResult.DECLINED) {
        <sag-ui-textarea
            [required]="true"
            label="Reason for Denial"
            formControlName="reasonForDenial"
        ></sag-ui-textarea>
        <sag-ui-select [required]="true" label="Select Next Step:" formControlName="nextStep">
            @for (option of nextSteps | keyvalue; track $index) {
            <sag-ui-option [value]="option.value">{{ option.value }}</sag-ui-option>
            }
        </sag-ui-select>
        }
    </div>
    @if (!disabled) {
    <sag-ui-button
        icon="checkmark-large"
        size="sm"
        class="mt-4"
        [disabled]="invalid"
        [loading]="submitting()"
        (click)="submit()"
        >Save</sag-ui-button
    >
    }
</section>
}
